import React from 'react'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import MainForm from './mainForm'

const portletBreadcrumbs = [
  { name: 'Activos Fijos', path: `/${CodigosTransaccionesConstant.ACTIVOSFIJOS_LISTA}` },
  { name: 'Nuevo' }
]

const NuevoPage = () => {
  return (
    <Portlet>
      <Portlet.Header title='Activos Fijos' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoPage)
